var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.224,
    height: 45.219,
    viewBox: "0 0 45.224 45.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.224,
    height: 45.219,
    fill: "#5d5d5d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4,45.219H7.827A7.827,7.827,0,0,1,0,37.4V7.827A7.827,7.827,0,0,1,7.827,0H37.4a7.827,7.827,0,0,1,7.827,7.827V37.4A7.827,7.827,0,0,1,37.4,45.219",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.545,154.309c.158-.716.351-1.591.549-2.462.27-1.2.532-2.408.826-3.6a.558.558,0,0,0-.2-.644c-1.51-1.312-3.006-2.641-4.519-3.953a1.243,1.243,0,0,1-.492-1.323,1.174,1.174,0,0,1,1.119-.909l3.337-.308c.967-.089,1.93-.187,2.9-.256.262-.02.288-.2.374-.363.785-1.835,1.579-3.668,2.35-5.512a1.237,1.237,0,0,1,2.388,0c.771,1.841,1.568,3.674,2.345,5.515a.518.518,0,0,0,.506.374c1.976.161,3.953.345,5.929.532.895.083,1.378.575,1.335,1.323a1.318,1.318,0,0,1-.529.929c-1.438,1.251-2.839,2.52-4.289,3.74a1,1,0,0,0-.385,1.151c.454,1.838.863,3.685,1.28,5.532a1.246,1.246,0,0,1-.949,1.654,1.355,1.355,0,0,1-1-.265c-1.691-1.013-3.383-2.014-5.066-3.043a.618.618,0,0,0-.748,0c-1.706,1.038-3.429,2.054-5.143,3.084a1.217,1.217,0,0,1-1.913-1.2",
    transform: "translate(-117.365 -122.286)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatedIcon);
export default __webpack_public_path__ + "static/media/rated_icon.deae78e48f91ad82173605cd9eeef1eb.svg";
export { ForwardRef as ReactComponent };